import _default from './Statistic';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Statistic/index.js
// module id = 1818
// module chunks = 0